<main class="main">
    <div class="main-wrapper">
      <section class="padding-first about1" id="about_us">
        <div class="container">

          <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
            <div class="icon-back">
              <span>Back</span>
            </div>
          </a>


          <div>
            <div class="bl-rows">
              <div class="text">
                <h2>Gennius XYZ Appoints Öznur Demir as Vice President of Global Marketing</h2>

                <span>By Gennius May 02, 2025</span>
              </div>
              <div class="img">
                <img src="./assets/img/gennius/bg-inside-notice15.png">
              </div>
            </div>
          </div>

          <div class="bl-center">
            <p><strong>Miami, USA </strong> &ndash; Gennius XYZ is proud to announce the appointment of <strong>&Ouml;znur Demir</strong>  as <strong>Vice President of Global Marketing,</strong>  reinforcing its strategic focus on global brand expansion and partner activation. &Ouml;znur brings a distinguished track record in marketing leadership across <strong>FMCG, consumer electronics, and fintech,</strong>  having successfully delivered large-scale, results-driven campaigns in multinational organizations.</p>
            <p>"&Ouml;znur's creative leadership, data-led mindset, and deep expertise in consumer activation are exactly what Gennius XYZ needs as we enter a new chapter of growth. Her appointment represents a pivotal step in elevating our global brand presence and supporting our mission to unlock new value for our partners and clients," said <strong>Ruben Salazar Genovez,</strong>  CEO of Gennius XYZ.</p>
            <p>In her new role, &Ouml;znur will lead Gennius XYZ's global marketing strategy, focusing on <strong>user activation, brand visibility, and revenue generation across key markets.</strong>  She will play a key role in helping our partners unlock new monetization opportunities through smarter, bolder marketing and support our expansion into new geographies and verticals.</p>
            <p>Prior to joining Gennius XYZ, &Ouml;znur held senior marketing roles in leading global companies where she drove brand growth, built integrated marketing strategies, and launched award-winning campaigns at scale. Her consumer-centric approach and passion for innovation will help cement Gennius XYZ's position as a global leader in <strong>digital engagement and loyalty innovation.</strong> </p>
            <p>&Ouml;znur's arrival marks another milestone in Gennius XYZ&rsquo;s evolution into a next-generation digital infrastructure company, delivering scalable, AI-powered solutions that convert rewards assets into universal digital value.<br />We are excited to welcome &Ouml;znur to the team and look forward to her impact on our growth journey.</p>
            <p>For more information about <strong>Gennius XYZ</strong>, please visit <a
                href="https://gennius.xyz/"><strong>www.gennius.xyz</strong></a>.</p>


          </div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
